import type { DefaultOptionType } from 'antd/lib/select';

export const filterSort = (optionA: DefaultOptionType, optionB: DefaultOptionType): number =>
  typeof optionA?.label === 'string' && typeof optionB?.label === 'string'
    ? optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase(), undefined, { numeric: true })
    : 0;
